import { TCaseFilter } from "src/aadeCase/data-access/types";
import React, { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import CaseFilters from "src/aadeCase/components/CaseFilters";
import { MaterialReactTable, MRT_TableInstance } from "material-react-table";

interface TCaseSearchOrchestratorProps {
  title: string;
  subtitle?: string;
  filters: TCaseFilter[];
  handleSearch: (data: any) => void;
  table: MRT_TableInstance<any>;
  tabComponent?: ReactNode;
  infoMessageComponent?: ReactNode;
}

export default function AadeCaseSearchOrchestrator(
  props: TCaseSearchOrchestratorProps,
) {
  const {
    title,
    subtitle,
    filters,
    handleSearch,
    table,
    tabComponent,
    infoMessageComponent,
  } = props;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        width: "80vw",
        mx: "auto",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography variant="h5">{title}</Typography>
        {subtitle && <Typography variant="subtitle1">{subtitle}</Typography>}
      </Box>
      {infoMessageComponent}
      {tabComponent}
      <CaseFilters filters={filters} onSuccess={handleSearch} />

      <MaterialReactTable table={table} />
    </Box>
  );
}
